export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/[0.08] py-14"
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-center">
          <div className="flex items-center gap-3">
            <img
              src="/triarch-logo-gold.png"
              alt="Triarch"
              className="h-6 w-6 opacity-80"
            />
            <span className="font-display text-sm tracking-[0.34em] text-white/80">
              TRIARCH
            </span>
          </div>
          <span className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-white/30">
            Private Infrastructure
          </span>
          <a
            href="mailto:contact@triarch.io"
            data-testid="site-footer-contact"
            className="font-mono-accent text-xs uppercase tracking-[0.22em] text-white/50 transition-colors duration-300 hover:text-white"
          >
            Contact
          </a>
        </div>
        <div className="mt-10 flex flex-col gap-2 border-t border-white/[0.05] pt-6 sm:flex-row sm:items-center sm:justify-between">
          <span className="font-mono-accent text-[10px] tracking-[0.2em] text-white/20">
            © {year} TRIARCH — ALL VECTORS RESERVED
          </span>
          <span className="font-mono-accent text-[10px] tracking-[0.2em] text-white/20">
            CLEARANCE: INTERNAL
          </span>
        </div>
      </div>
    </footer>
  );
};
